// @leyro/api-client · tokenStore.js
// Adaptador para almacenamento de tokens. Web inxecta unha implementación
// con localStorage; mobile inxecta unha con AsyncStorage.

/**
 * @typedef {Object} TokenStore
 * @property {() => string|null|Promise<string|null>} getAccess
 * @property {() => string|null|Promise<string|null>} getRefresh
 * @property {(access: string, refresh?: string) => void|Promise<void>} set
 * @property {() => void|Promise<void>} clear
 */

/**
 * Crea un TokenStore baseado en localStorage. Útil para apps/web.
 * As claves seguen a convención histórica (`ms_token`, `ms_refresh_token`)
 * para compatibilidade con sesións xa abertas.
 *
 * @param {Object} [options]
 * @param {string} [options.accessKey]
 * @param {string} [options.refreshKey]
 * @returns {TokenStore}
 */
export const createLocalStorageTokenStore = ({
  accessKey = "ms_token",
  refreshKey = "ms_refresh_token",
} = {}) => ({
  getAccess:  () => (typeof localStorage === "undefined" ? null : localStorage.getItem(accessKey)),
  getRefresh: () => (typeof localStorage === "undefined" ? null : localStorage.getItem(refreshKey)),
  set: (access, refresh) => {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(accessKey, access);
    if (refresh) localStorage.setItem(refreshKey, refresh);
  },
  clear: () => {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(accessKey);
    localStorage.removeItem(refreshKey);
  },
});

/**
 * Crea un TokenStore en memoria. Útil para tests ou execucións sen persistencia.
 * @returns {TokenStore}
 */
export const createMemoryTokenStore = () => {
  let access = null;
  let refresh = null;
  return {
    getAccess:  () => access,
    getRefresh: () => refresh,
    set: (a, r) => { access = a; if (r) refresh = r; },
    clear: () => { access = null; refresh = null; },
  };
};
